<template>
  <form style="display: none" method="post" id="exportForm" :action="url">
    <input v-if="params !== false" name="params" type="hidden" id="exportParams"/>
    <input name="__sg_client_token" type="hidden" :value="token"/>
  </form>
</template>

<script>
export default {
  name: "HiddenDownloadForm",
  expose: ["download"],
  methods: {
    download(url, params){
      console.log("params", params);
      this.url = url
      this.token = this.$store.getters.token
      if (params){
        this.params = params
        this.$nextTick(() => {document.getElementById("exportParams").value = JSON.stringify(this.params)})
      }
      this.$nextTick(() => {document.getElementById("exportForm").submit()})
    }
  },
  data(){
    return {
      url: "",
      params: false,
      token: ""
    }
  }
}
</script>